import { render, staticRenderFns } from "./EFUpdateWarning.vue?vue&type=template&id=0eb07961"
import script from "./EFUpdateWarning.vue?vue&type=script&lang=js"
export * from "./EFUpdateWarning.vue?vue&type=script&lang=js"
import style0 from "./EFUpdateWarning.vue?vue&type=style&index=0&id=0eb07961&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports